import { app } from "hf-rt";
import { ROOT, HOST_URL, GTM_PATH } from "./constants";
import "./i18n";
import "react-app-polyfill/ie11";
// import "react-app-polyfill/edge16";
import "react-app-polyfill/stable";
import "core-js/features/promise";

function loadGTM(src) {
  if (!src) return;

  const existingScript = document.querySelector(`script[src="${src}"]`);
  if (existingScript) return;

  const script = document.createElement("script");
  script.src = src;
  document.head.appendChild(script);
}

loadGTM(GTM_PATH);

setTimeout(() => {
  if (window.OneTrust) {
    const css = window.OneTrust.getCSS();
    const style = document.createElement("style");
    const styleText = document.createTextNode(css);
    style.appendChild(styleText);
    document.head.appendChild(style);
  }
}, 1000);

//註冊頁面
app.page({
  path: `${ROOT}/productDetail`,
  component: require("./pages/ProductDetail")
});

app.page({
  path: `${ROOT}/:lang/productDetail`,
  component: require("./pages/ProductDetail")
});

app.page({
  path: `${ROOT}/checkout`,
  component: require("./pages/Checkout")
});

app.page({
  path: `${ROOT}/:lang/checkout`,
  component: require("./pages/Checkout")
});

app.page({
  path: `${ROOT}/verificationEmail`,
  component: require("./components/Collapse/VerificationEmail")
});

app.page({
  path: `${ROOT}/:lang/verificationEmail`,
  component: require("./components/Collapse/VerificationEmail")
});

app.page({
  path: `${ROOT}/resultFail`,
  component: require("./pages/ResultFail")
});

app.page({
  path: `${ROOT}/:lang/resultFail`,
  component: require("./pages/ResultFail")
});

app.page({ path: `${ROOT}/result`, component: require("./pages/Result") });

app.page({
  path: `${ROOT}/:lang/result`,
  component: require("./pages/Result")
});

app.page({ path: `${ROOT}/register`, component: require("./pages/Register") });

app.page({
  path: `${ROOT}/:lang/register`,
  component: require("./pages/Register")
});

app.page({
  path: `${ROOT}/check-register`,
  component: require("./pages/CheckRegister")
});

app.page({
  path: `${ROOT}/:lang/check-register`,
  component: require("./pages/CheckRegister")
});

app.page({
  path: `${ROOT}/search`,
  component: require("./pages/Search")
});

app.page({
  path: `${ROOT}/:lang/search`,
  component: require("./pages/Search")
});

app.page({
  path: `${ROOT}/wishlist`,
  component: require("./pages/WishList")
});

app.page({
  path: `${ROOT}/:lang/wishlist`,
  component: require("./pages/WishList")
});

app.page({ path: "*", component: require("./components/ErrorPage") });

//註冊模型
app.model(require("./models/product"));
app.model(require("./models/cart"));
app.model(require("./models/order"));
app.model(require("./models/validate"));
app.model(require("./models/login"));
app.model(require("./models/myFav"));
app.model(require("./models/countryList.js"));
app.model(require("./models/browsingHistory.js"));
app.model(require("./models/recommendation"));
app.model(require("./models/myBag"));
app.model(require("./models/addresses"));
app.model(require("./models/customer"));
app.model(require("./models/loading"));
app.model(require("./models/pickUpInStore"));
app.model(require("./models/loginPopup"));
app.model(require("./models/showMiniCart"));
app.model(require("./models/errorPage"));
app.model(require("./models/register"));
app.model(require("./models/mobileMenu"));
app.model(require("./models/enlargeImage"));
app.model(require("./models/chosenFilter"));
app.model(require("./models/scaleProduct"));
app.model(require("./models/searchKeywords"));
app.model(require("./models/sortByFitler"));
app.model(require("./models/coupon"));

//註冊api

app.api({
  name: "shippingFeeAndDeliveryDate",
  path: `${HOST_URL}/shopping/v1/carts/shippingFeeAndDeliveryDate`
});

app.api({
  name: "tempOrder",
  path: `${HOST_URL}/shopping/v1/compositions/temp-orders`
});

app.api({
  name: "deliveries",
  path: `${HOST_URL}/shopping/v1/compositions/deliveries`
});
app.api({
  name: "places",
  path: `${HOST_URL}/shopping/v1/compositions/deliveries/places`
});
app.api({
  name: "customer",
  path: `${HOST_URL}/shopping/v1/compositions/customers/info`
});
app.api({
  name: "addresses",
  path: `${HOST_URL}/shopping/v1/customers/addresses`
});
app.api({
  name: "stores",
  path: `${HOST_URL}/shopping/v1/stores`
});
app.api({
  name: "region",
  path: `${HOST_URL}/shopping/v1/deliveries/regions/info`
});
app.api({
  name: "login",
  path: `${HOST_URL}/user/login`
});
app.api({
  name: "product",
  path: `${HOST_URL}/shopping/v1/compositions/productDetails/info`
});
app.api({
  name: "cart",
  path: `${HOST_URL}/shopping/v1/compositions/miniCart`
});

app.api({ name: "insertCart", path: `${HOST_URL}/shopping/v1/cartItems` });
app.api({ name: "sendEmail", path: `${HOST_URL}/sendEmail` });
app.api({ name: "login", path: `${HOST_URL}/user/login` });
app.api({
  name: "myFav",
  path: `${HOST_URL}/shopping/v1/compositions/wishList`
});
app.api({
  name: "wishListItems",
  path: `${HOST_URL}/shopping/v1/wishListItems`
});
app.api({
  name: "countriesList",
  path: `${HOST_URL}/shopping/v1/dutytax/countries/info`
});
//取得貨幣menu地區
app.api({
  name: "menuCountriesList",
  path: `${HOST_URL}/shopping/v1/static/regions/info`
});
app.api({
  name: "countryDetailInfo",
  path: `${HOST_URL}/shopping/v1/dutytax/info`
});
app.api({
  name: "browsingHistory",
  path: `${HOST_URL}/shopping/v1/compositions/browsingHistory`
});
app.api({
  name: "recommendation",
  path: `${HOST_URL}/shopping/v1/compositions/browsingHistory`
});
app.api({
  name: "test",
  path: "https://hkuat-pks.emphasis.com/eshop-hk/api/shopping/v1/channelCatalogItems/itemList?category=JEWELLERY&page=1"
});
app.api({
  name: "myBag",
  path: `${HOST_URL}/shopping/v1/compositions/mybags`
});
app.api({
  name: "removeMyBagItem",
  path: `${HOST_URL}/shopping/v1/cartItems`
});
app.api({
  name: "pickUpInStore",
  path: `${HOST_URL}/shopping/v1/stores`
});

//啟動app
app.start("root");
